/**
 * This function checks if the current user browser has time is in 12-hour format.
 */
// TODO: maybe rename to isTimeIn12HourFormat or something like that?
export const isTimeWithPeriod = () => {
  const timeString = new Date().toLocaleTimeString().toUpperCase();

  return timeString.includes('AM') || timeString.includes('PM');
};
